import React, { Component } from "react";
import { t } from "../../../components/CustomComponent.js";
import "./checklist-tree.css";

export const TEMPLATE_STATUSES = ["draft", "active", "inactive"];

export const statusLabel = (status) => t(`ct_status_${status}`);
export const statusHint = (status) => t(`ct_status_${status}_hint`);

// ป้ายสถานะ (ใช้ในการ์ดรายการเทมเพลต)
export const StatusPill = ({ status }) => <span className={`ct-stpill ${status}`}>{statusLabel(status)}</span>;

// ปุ่มเลือกสถานะ 3 อันติดกัน (Draft เหลือง / Active เขียว / Inactive เทา) เปลี่ยนด้วยคีย์ลูกศรได้
export default class StatusPicker extends Component {
  refs_ = {};

  select = (status, focus) => {
    this.props.onChange(status);
    if (focus) setTimeout(() => this.refs_[status]?.focus(), 0);
  };

  onKeyDown = (e) => {
    const { value } = this.props;
    const i = TEMPLATE_STATUSES.indexOf(value);
    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      e.preventDefault();
      this.select(TEMPLATE_STATUSES[(i + 1) % 3], true);
    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      e.preventDefault();
      this.select(TEMPLATE_STATUSES[(i + 2) % 3], true);
    }
  };

  render() {
    const { value } = this.props;
    return (
      <div>
        <span className="form-label text-14 fw-bold text-dark d-block" id="ct-status-label">
          {t("ct_status")}
        </span>
        <div className="ct-seg" role="radiogroup" aria-labelledby="ct-status-label" onKeyDown={this.onKeyDown}>
          {TEMPLATE_STATUSES.map((st) => (
            <button
              key={st}
              type="button"
              role="radio"
              data-st={st}
              aria-checked={value === st}
              tabIndex={value === st ? 0 : -1}
              ref={(el) => {
                this.refs_[st] = el;
              }}
              onClick={() => this.select(st)}
            >
              {statusLabel(st)}
            </button>
          ))}
        </div>
        <span className="ct-sthint" aria-live="polite">
          {statusHint(value)}
        </span>
      </div>
    );
  }
}
